import {ModuleWithProviders, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {LoadingComponent} from './loading/loading.component';
import {TbdComponent} from './tbd/tbd.component';
import {ControlMsgComponent} from './elements/controlMsg.component';
import {FormMsgComponent} from './elements/formMsg.component';
import {PollTimerComponent} from './pollTimer';
import {
    NumberingLabelPipe,
    ObjectFilterPipe,
    OrderedValuesPipe,
    QuestionLabelPipe, SafeUrlPipe,
    TimeLimitPipe,
    TruncateTextPipe
} from './pipes';
import {SliderComponent} from './slider/slider.component';
import {AlertComponent} from './components/alert.component';
import {ScriptHackComponent} from './components/scriptHack.component';
import {RouterModule} from '@angular/router';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MDBBootstrapModulesPro} from 'ng-uikit-pro-standard';
import {ModalComponent} from './components/modal.component';
import {SweetAlert2Module} from '@toverux/ngx-sweetalert2';

/**
 * Do not specify providers for modules that might be imported by a lazy loaded module.
 */

@NgModule({

    imports: [CommonModule, FormsModule, ReactiveFormsModule,
        RouterModule,
        SweetAlert2Module,
        MDBBootstrapModulesPro.forRoot()
    ],

    declarations: [LoadingComponent, TbdComponent,
        ControlMsgComponent, FormMsgComponent,

        PollTimerComponent,
        TimeLimitPipe, OrderedValuesPipe, QuestionLabelPipe, NumberingLabelPipe, ObjectFilterPipe, TruncateTextPipe, SafeUrlPipe,
        SliderComponent,
        AlertComponent, ModalComponent,
        ScriptHackComponent
    ],

    exports: [LoadingComponent, TbdComponent,
        ControlMsgComponent, FormMsgComponent,

        PollTimerComponent,
        TimeLimitPipe, OrderedValuesPipe, QuestionLabelPipe, NumberingLabelPipe, ObjectFilterPipe, TruncateTextPipe, SafeUrlPipe,
        SliderComponent,
        AlertComponent, ModalComponent,
        ScriptHackComponent
    ]
})
export class HbsComponentsModule {
    static forRoot(): ModuleWithProviders {
        return {
            ngModule: HbsComponentsModule
        };
    }
}
